import IPassengerPhonNumberViewModel from "@/components/Passenger/models/IPassengerPhoneNumberViewModel";
import {
  IEntity,
  IEntityMapping,
  IExcelRow,
  IPropertyMapping,
  IPropertyUpdate
} from "@/typings/import";
import { EEntityImportState, EEntityMatchType } from "../../enums";
import PropertyUpdateHelper from '../PropertyUpdateHelper';

export default class PhoneNumberEntity
  implements IEntity<IPassengerPhonNumberViewModel> {
  entity?: IPassengerPhonNumberViewModel;
  matchedBy: EEntityMatchType;
  propertyUpdates: Array<IPropertyUpdate<IPassengerPhonNumberViewModel>>;
  excelRowIndex: number;
  selected: boolean;
  importState: EEntityImportState;

  constructor(
    row: IExcelRow,
    index: number,
    mapping: IEntityMapping<IPassengerPhonNumberViewModel>
  ) {
    const propertyUpdates: Array<IPropertyUpdate<IPassengerPhonNumberViewModel>> = mapping.props.map(p => {
      const propertyUpdate: IPropertyUpdate<IPassengerPhonNumberViewModel> = {
        propertyName: p.propertyName,
        propertyType: p.propertyType,
        rowKey: p.cell ? p.cell : '',
        oldValue: null,
        newValue: PropertyUpdateHelper.getNewValueFromMapping(p, row),
        doNotUpdate: false,
        overrideValue: null,
        isValid: () => false,
      };
      propertyUpdate.isValid = this.getIsValid(propertyUpdate.propertyName, propertyUpdate.newValue);
      return propertyUpdate;
    });
    this.propertyUpdates = propertyUpdates;
    this.matchedBy = EEntityMatchType.Unknown;
    this.excelRowIndex = index;
    this.selected = false;
    this.importState = EEntityImportState.Mapped;
  }

  onMappingChanged(mapping: IEntityMapping<IPassengerPhonNumberViewModel>, row: IExcelRow) {
    mapping.props.forEach(p => {
      const propertyUpdate = this.propertyUpdates.find(pu => pu.propertyName === p.propertyName);
      if (propertyUpdate) {
        propertyUpdate.newValue = PropertyUpdateHelper.getNewValueFromMapping(p, row);
      }
    });
  }
  
  isValid(): boolean {
    return this.propertyUpdates.every(pu => pu.isValid());
  }

  private getIsValid(propertyName: string, value: object) {
    if (propertyName === 'number') {
      // TODO: validation logic for phone number here
      return () => true;
    }
    return () => true;
  }

  private getNewValue(propertyMapping: IPropertyMapping, row: IExcelRow) {
    if (propertyMapping.useStatic) {
      return propertyMapping.static;
    }
    if (propertyMapping.cell) {
      return row.excelRowData[propertyMapping.cell];
    }
    return null;
  }
}
